module.exports = __webpack_public_path__ + "img/at_a_glance.19e806e0.jpg";